/** WARNING! This file is generated from GraphQL Schema, please do not modify!
 * Any modification will be overridden
 */
/** Status of applicant */
export enum ApplicantStatusEnum {
  Declined = "DECLINED",
  Pending = "PENDING",
}

/** Enum with appointment visibility */
export enum AppointmentVisibilityEnum {
  Default = "DEFAULT",
  Hidden = "HIDDEN",
  OnlyNonverifiedProfile = "ONLY_NONVERIFIED_PROFILE",
  OnlyVerifiedProfile = "ONLY_VERIFIED_PROFILE",
}

/** Enum with attendance actions */
export enum AttendanceActionEnum {
  ResendInvitation = "RESEND_INVITATION",
  SignOff = "SIGN_OFF",
}

/** Enum with attendance note types */
export enum AttendanceNoteTypeEnum {
  AdminExcuse = "ADMIN_EXCUSE",
  Common = "COMMON",
  CrewbossExcuse = "CREWBOSS_EXCUSE",
  Problematic = "PROBLEMATIC",
  StaffClockOut = "STAFF_CLOCK_OUT",
}

/** Enum with attendance presence values */
export enum AttendancePresenceEnum {
  Excused = "EXCUSED",
  Late = "LATE",
  Miss = "MISS",
  Pending = "PENDING",
  Present = "PRESENT",
}

/** Reconfirmation statuses for attendance */
export enum AttendanceReconfirmationStatusEnum {
  Confirmed = "CONFIRMED",
  Pending = "PENDING",
}

/** Enum with attendance status */
export enum AttendanceStatusEnum {
  AssignedByAdmin = "ASSIGNED_BY_ADMIN",
  AssignedByWorker = "ASSIGNED_BY_WORKER",
  ConfirmationConfirmed = "CONFIRMATION_CONFIRMED",
  ConfirmationPending = "CONFIRMATION_PENDING",
}

/** Enum with attribute type */
export enum AttributeTypeEnum {
  Bool = "BOOL",
  Choice = "CHOICE",
  Country = "COUNTRY",
  Date = "DATE",
  File = "FILE",
  Gallery = "GALLERY",
  Image = "IMAGE",
  Int = "INT",
  Multiplechoice = "MULTIPLECHOICE",
  Range = "RANGE",
  Text = "TEXT",
  Textarea = "TEXTAREA",
}

/** Enum with availability types (workerFilter) */
export enum AvailabilityTypeEnum {
  DemandNotAllocated = "DEMAND_NOT_ALLOCATED",
  JobDemand = "JOB_DEMAND",
  NoDemand = "NO_DEMAND",
  NoJobAvailable = "NO_JOB_AVAILABLE",
  Unavailable = "UNAVAILABLE",
  Working = "WORKING",
}

/** Avatar image variants */
export enum AvatarVariantsEnum {
  Thumb_200_200 = "THUMB_200_200",
  Thumb_500_500 = "THUMB_500_500",
}

/** Enum for bank account format */
export enum BankAccountFormat {
  Au = "AU",
  Common = "COMMON",
  Cz = "CZ",
  Dk = "DK",
  Es = "ES",
  Gb = "GB",
  Iban = "IBAN",
  It = "IT",
  Nl = "NL",
  Pl = "PL",
  Si = "SI",
}

/** Calendar event type */
export enum CalendarEventTypeEnum {
  Common = "COMMON",
  JobDemand = "JOB_DEMAND",
  System = "SYSTEM",
  Unavailable = "UNAVAILABLE",
}

/** Enum with CitizenshipAttribute values */
export enum CitizenshipAttributeEnum {
  /** Allow set attribute for any citizenship worker have */
  Any = "ANY",
  /** Allow set attribute only for same citizenship as agency */
  HomeCountry = "HOME_COUNTRY",
  /** Allow set attribute for citizenship which do not match with agency country */
  OtherCountry = "OTHER_COUNTRY",
}

/** Enum with company pay rating */
export enum CompanyPayRatingEnum {
  Bad = "BAD",
  God = "GOD",
  Good = "GOOD",
}

/** Enum with company statuses */
export enum CompanyStatusEnum {
  Active = "ACTIVE",
  Inactive = "INACTIVE",
}

/** Condition types */
export enum ConditionCategory {
  Badge = "BADGE",
  Contract = "CONTRACT",
  PersonalAttribute = "PERSONAL_ATTRIBUTE",
  Position = "POSITION",
  Profession = "PROFESSION",
  ProfileAttribute = "PROFILE_ATTRIBUTE",
  Role = "ROLE",
  Transport = "TRANSPORT",
  Worker = "WORKER",
}

/** Mapping of condition types to condition operators to prevent duplication of operators in badges / attributes */
export enum ConditionCategoryOperator {
  AttrBool = "ATTR_BOOL",
  AttrChoiceMultichoice = "ATTR_CHOICE_MULTICHOICE",
  AttrDefault = "ATTR_DEFAULT",
  AttrIntRange = "ATTR_INT_RANGE",
  BadgeDefault = "BADGE_DEFAULT",
  BadgeRanks = "BADGE_RANKS",
  Equality = "EQUALITY",
  MultiselectEquality = "MULTISELECT_EQUALITY",
  NumberWithoutEquality = "NUMBER_WITHOUT_EQUALITY",
  NumberWithEquality = "NUMBER_WITH_EQUALITY",
  WeekdayTimes = "WEEKDAY_TIMES",
}

/** Operator used in ratelist condition */
export enum ConditionOperator {
  Equal = "EQUAL",
  Exist = "EXIST",
  GreaterThan = "GREATER_THAN",
  GreaterThanOrEqual = "GREATER_THAN_OR_EQUAL",
  In = "IN",
  LessThan = "LESS_THAN",
  LessThanOrEqual = "LESS_THAN_OR_EQUAL",
  NotEqual = "NOT_EQUAL",
  NotExist = "NOT_EXIST",
  NotFilled = "NOT_FILLED",
  NotIn = "NOT_IN",
}

/** Types of condition used in ratelist */
export enum ConditionType {
  AttendanceBeginning = "ATTENDANCE_BEGINNING",
  AttendanceBeginningHoliday = "ATTENDANCE_BEGINNING_HOLIDAY",
  AttendanceLength = "ATTENDANCE_LENGTH",
  AttendanceOverlap = "ATTENDANCE_OVERLAP",
  AttendancePaymentMethod = "ATTENDANCE_PAYMENT_METHOD",
  Badge = "BADGE",
  Contract = "CONTRACT",
  PersonalAttribute = "PERSONAL_ATTRIBUTE",
  PositionBeginning = "POSITION_BEGINNING",
  PositionLength = "POSITION_LENGTH",
  PositionOverlap = "POSITION_OVERLAP",
  PositionRole = "POSITION_ROLE",
  PositionSize = "POSITION_SIZE",
  Profession = "PROFESSION",
  ProfileAttribute = "PROFILE_ATTRIBUTE",
  Rating = "RATING",
  ShiftSize = "SHIFT_SIZE",
  TransportDirection = "TRANSPORT_DIRECTION",
  TransportDistance = "TRANSPORT_DISTANCE",
  TransportDuration = "TRANSPORT_DURATION",
  TransportRole = "TRANSPORT_ROLE",
  TransportTripBeginning = "TRANSPORT_TRIP_BEGINNING",
  TransportTripOverlap = "TRANSPORT_TRIP_OVERLAP",
}

/** Condition data types */
export enum ConditionValueType {
  Date = "DATE",
  /** A country, the holidays of it that count, and the time windows within such a day */
  NationalHolidayTimes = "NATIONAL_HOLIDAY_TIMES",
  Number = "NUMBER",
  Select = "SELECT",
  String = "STRING",
  WeekdayTimes = "WEEKDAY_TIMES",
}

/** Contract type statuses */
export enum ContractTypeStatus {
  Active = "ACTIVE",
  Inactive = "INACTIVE",
}

/** Types of custom intervals used in ratelist */
export enum CustomIntervalType {
  BreakPenalty = "BREAK_PENALTY",
  DailyOvertime = "DAILY_OVERTIME",
  Intersection = "INTERSECTION",
  NationalHolidays = "NATIONAL_HOLIDAYS",
  Time = "TIME",
  WeeklyOvertime = "WEEKLY_OVERTIME",
  WorkedDuration = "WORKED_DURATION",
}

/** Countries, for which economic subject providers is available */
export enum EconomicSubjectCountry {
  Cz = "CZ",
  Dk = "DK",
  Pl = "PL",
  Uk = "UK",
}

/** Feature list for "feature flag" functionality purpose */
export enum FeatureEnum {
  AutoTextDirection = "AUTO_TEXT_DIRECTION",
  Awr = "AWR",
  CustomDocumentTemplates = "CUSTOM_DOCUMENT_TEMPLATES",
  ElectronicSignatures = "ELECTRONIC_SIGNATURES",
  OnsitePresence = "ONSITE_PRESENCE",
  PaidBreaks = "PAID_BREAKS",
  PushNotifications = "PUSH_NOTIFICATIONS",
  Ratelists = "RATELISTS",
  SignotecSignatures = "SIGNOTEC_SIGNATURES",
  StaffClockIn = "STAFF_CLOCK_IN",
  Transport = "TRANSPORT",
  TurnOffLegacyRatelists = "TURN_OFF_LEGACY_RATELISTS",
}

/** Supported countries for national holidays */
export enum HolidayCountry {
  Au = "AU",
  Be = "BE",
  Cz = "CZ",
  Dk = "DK",
  Es = "ES",
  Gb = "GB",
  Nl = "NL",
  Sk = "SK",
  Us = "US",
}

/** Mode used to perform join mutation */
export enum JoinModeEnum {
  /** Join worker to position without any information about linked positions (default) */
  JoinSimple = "JOIN_SIMPLE",
  /** Join worker to position only (without joining into linked ones) */
  JoinWithoutGrouped = "JOIN_WITHOUT_GROUPED",
  /** Join worker to position and all other empty grouped positions */
  JoinWithGrouped = "JOIN_WITH_GROUPED",
}

/** Categories of margin breakdown (attendance, tag, transport there, transport back, flat-priced order items) */
export enum MarginCategory {
  Attendance = "ATTENDANCE",
  /**
   * Flat-priced order items (manual rows, reimbursements, inventory) - the
   * lines not represented by calculated rates. Loaded order-level only.
   */
  OrderItem = "ORDER_ITEM",
  Tag = "TAG",
  TransportBack = "TRANSPORT_BACK",
  TransportThere = "TRANSPORT_THERE",
}

/** Enum with message severity type */
export enum MessageSeverity {
  Error = "ERROR",
  Warning = "WARNING",
}

/** List of message template categories */
export enum MessageTemplateCategoriesEnum {
  OrderPublished = "ORDER_PUBLISHED",
}

/** Possible notification channels */
export enum NotificationChannelEnum {
  Email = "EMAIL",
  Interactive = "INTERACTIVE",
  Push = "PUSH",
  Smart = "SMART",
  Sms = "SMS",
}

/** Enum with operator value types */
export enum OperatorValueTypeEnum {
  Boolean = "BOOLEAN",
  List = "LIST",
  Number = "NUMBER",
  String = "STRING",
}

/** Enum with order direction */
export enum OrderDirectionTypeEnum {
  Asc = "ASC",
  Desc = "DESC",
}

/** Payment method statuses */
export enum PaymentMethodStatus {
  Active = "ACTIVE",
  Inactive = "INACTIVE",
}

/** Payment method types */
export enum PaymentMethodType {
  Payout = "PAYOUT",
  Reimbursement = "REIMBURSEMENT",
}

/** Decision for a pending profile change */
export enum PendingChangeDecisionEnum {
  Approved = "APPROVED",
  Rejected = "REJECTED",
}

/** Placeholder data types */
export enum PlaceholderTypeEnum {
  Boolean = "BOOLEAN",
  Currency = "CURRENCY",
  Date = "DATE",
  Datetime = "DATETIME",
  File = "FILE",
  FileList = "FILE_LIST",
  Image = "IMAGE",
  Text = "TEXT",
}

/** Enum with position roles */
export enum PositionRoleEnum {
  /** Position role lead worker */
  Crewboss = "CREWBOSS",
  /** Position role standby. */
  Standby = "STANDBY",
  /** Position role staff */
  Worker = "WORKER",
}

/** Enum with position status */
export enum PositionStatusEnum {
  /** Closing position by closing CB */
  CbCompleted = "CB_COMPLETED",
  /** Completed position */
  Completed = "COMPLETED",
  /** Opened position */
  Opened = "OPENED",
  /** Opened position, but hidden */
  OpenedHidden = "OPENED_HIDDEN",
  /** Over position */
  Over = "OVER",
  /** Pending position */
  Pending = "PENDING",
  /** Running position */
  Running = "RUNNING",
}

/** Derived status of a worker profile approval */
export enum ProfileApprovalStatusEnum {
  Approved = "APPROVED",
  Declined = "DECLINED",
  NotFilled = "NOT_FILLED",
  PendingChanges = "PENDING_CHANGES",
  PendingReview = "PENDING_REVIEW",
}

/** Categories of rates (wage/price) */
export enum RateCategory {
  Price = "PRICE",
  Wage = "WAGE",
}

/** Types of rate used in ratelist */
export enum RateType {
  Percentage = "PERCENTAGE",
  Simple = "SIMPLE",
}

/** Statuses used in ratelist */
export enum RatelistStatus {
  Active = "ACTIVE",
  Archived = "ARCHIVED",
  Draft = "DRAFT",
}

/** Types of ratelist */
export enum RatelistType {
  Price = "PRICE",
  TagPrice = "TAG_PRICE",
  TagWage = "TAG_WAGE",
  TransportPrice = "TRANSPORT_PRICE",
  TransportWage = "TRANSPORT_WAGE",
  Wage = "WAGE",
}

/** Enum with rating values */
export enum RatingEnum {
  Admin = "ADMIN",
  Cb = "CB",
  Default = "DEFAULT",
  Duty = "DUTY",
  Excused = "EXCUSED",
  Late = "LATE",
  Na = "NA",
  Wb = "WB",
}

/** Enum with ReportType values */
export enum ReportTypeEnum {
  Bad = "BAD",
  Good = "GOOD",
  Neutral = "NEUTRAL",
}

/** Enum with types of role status */
export enum RoleStatusEnum {
  Active = "ACTIVE",
  Blocked = "BLOCKED",
  Deleted = "DELETED",
  Hibernated = "HIBERNATED",
}

/** Direction of unit rounding: UP, DOWN, NEAREST (midpoint goes up) or GRACE_UP (down within the grace period, up beyond it) */
export enum RoundingDirection {
  Down = "DOWN",
  GraceUp = "GRACE_UP",
  Nearest = "NEAREST",
  Up = "UP",
}

/** Kind of unit a rounding applies to: TIME (base in minutes) or DISTANCE (base in the agency distance unit) */
export enum RoundingUnitKind {
  Distance = "DISTANCE",
  Time = "TIME",
}

/** Enum with sex values */
export enum SexEnum {
  Female = "FEMALE",
  Male = "MALE",
  NonBinary = "NON_BINARY",
}

/** Determine type of associated file for shift */
export enum ShiftFileTypeEnum {
  /** attachment uploaded by crewboss */
  CrewbossAttachment = "CREWBOSS_ATTACHMENT",
  /** file for description from admin to crewboss */
  CrewbossDescription = "CREWBOSS_DESCRIPTION",
  /** file for public description from admin to all workers */
  PublicDescription = "PUBLIC_DESCRIPTION",
  /** attachment uploaded by worker */
  WorkerAttachment = "WORKER_ATTACHMENT",
}

/** Field sort direction enum */
export enum SortDirectionEnum {
  Asc = "ASC",
  Desc = "DESC",
}

/** Enum with staff clock-in geolocation error code values */
export enum StaffClockInErrorCodeEnum {
  GpsUnavailable = "GPS_UNAVAILABLE",
  PermissionDenied = "PERMISSION_DENIED",
  PositionUnavailable = "POSITION_UNAVAILABLE",
  Timeout = "TIMEOUT",
}

/** Tag choosability values */
export enum TagChoosability {
  Admin = "ADMIN",
  Client = "CLIENT",
}

/** Tag visibilities */
export enum TagVisibility {
  Admin = "ADMIN",
  Client = "CLIENT",
  Public = "PUBLIC",
  SignedWorkers = "SIGNED_WORKERS",
  Worker = "WORKER",
}

/** Enum for transport attendance role */
export enum TransportAttendanceRole {
  Driver = "DRIVER",
  NoTransport = "NO_TRANSPORT",
  Passenger = "PASSENGER",
}

/** Enum for TransportTrip direction */
export enum TransportDirection {
  Back = "BACK",
  There = "THERE",
}

/** Names of actual units used with ratelist Units (e.g. "HOURS" for time related, "KILOMETER" for distance) */
export enum UnitName {
  Currency = "CURRENCY",
  Hour = "HOUR",
  Kilometer = "KILOMETER",
  Mile = "MILE",
  Pieces = "PIECES",
}

/** Types of units (intervals) used in ratelist */
export enum UnitType {
  Custom = "CUSTOM",
  Flat = "FLAT",
  Overtime = "OVERTIME",
  Planned = "PLANNED",
  TotalPercentage = "TOTAL_PERCENTAGE",
  TransportDistance = "TRANSPORT_DISTANCE",
  TransportDuration = "TRANSPORT_DURATION",
  Worked = "WORKED",
}

/** Base user roles (ADMIN, CLIENT, WORKER) */
export enum UserRoleEnum {
  Admin = "ADMIN",
  Client = "CLIENT",
  Worker = "WORKER",
}

/** Enum with user statuses */
export enum UserStatus {
  Confirmed = "CONFIRMED",
  /** user that was created by admin and later invited to sign in himself */
  Invited = "INVITED",
  /** user that signed up, but did not activate account yet */
  Pending = "PENDING",
  /** user without access rights (not invited, not registered; created manually by admin) */
  Shell = "SHELL",
}
